import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createUser,
  updateUser,
  deleteUser,
  deactivateUser,
  activateUser,
  deleteErrorUser,
  updateUserWithSignature,
} from '../../actions/user';
import { findAllUserRole } from '../../actions/userRole';
import UserTable from '../User/UserTable';
import { TableContainer } from '../Reusable/TableContainer';
import { TableHeader } from '../../enums/UserEnums';
import ModalForAddUser from '../User/ModalForAddUser';

const UserContainer = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const userReducer = useSelector((state) => state.user);
  const userRoleReducer = useSelector((state) => state.userRole);
  const securityReducer = useSelector((state) => state.security);

  const showModal = (e) => {
    setShow(true);
  };

  const handleAdd = (user) => {
    dispatch(createUser(user, handlePreviewClose));
  };

  useEffect(() => {
    dispatch(findAllUserRole());
  }, []);

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const isModalOpened = (show) => {
    return show;
  };

  const clearValidationErrors = () => {
    dispatch(deleteErrorUser());
  };

  return (
    <>
      <TableContainer
        cardTitle={TableHeader.titleForUserTable}
        showModal={showModal}
        fullWidth
      >
        <UserTable
          deleteUser={deleteUser}
          updateUser={updateUserWithSignature}
          deactivateUser={deactivateUser}
          activateUser={activateUser}
          createUser={createUser}
          isModalOpened={isModalOpened}
          dispatch={dispatch}
          userReducer={userReducer}
          userRoleReducer={userRoleReducer}
          securityReducer={securityReducer}
          clearValidationErrors={clearValidationErrors}
        />
      </TableContainer>
      {show && (
        <ModalForAddUser
          handleAdd={handleAdd}
          handleClose={handlePreviewClose}
          show={show}
          userReducer={userReducer}
          userRoleReducer={userRoleReducer}
        />
      )}
    </>
  );
};

export default UserContainer;
